export default "__VITE_ASSET__C$DHt0Nq__ 480w, __VITE_ASSET__CMT88lV3__ 768w, __VITE_ASSET__Z5rii9RD__ 1200w, __VITE_ASSET__DWA6Rq_9__ 1600w";